import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Input, Button } from "semantic-ui-react";
import { auth } from "../../firebase";
import { toast } from "react-toastify";
import { createUpdateUser } from "../../helpers/auth";
import Layout from "../../hoc/Layout";

const RegisterComplete = ({ history }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    setEmail(window.localStorage.getItem("registrationEmail"));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // simple validation
    if (!email || !password) {
      toast.error("Email & Password are required.");
      return;
    }
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return;
    }
    try {
      const result = await auth.signInWithEmailLink(
        email,
        window.location.href
      );
      // console.log(result);
      if (result.user.emailVerified) {
        // remove user from localStorage
        window.localStorage.removeItem("registrationEmail");
        // get user id token
        let user = auth.currentUser;
        await user.updatePassword(password);
        const idTokenResult = await user.getIdTokenResult();
        // redux store
        // redirect
        createUpdateUser(idTokenResult.token)
          .then((res) =>
            dispatch({
              type: "LOGGED_IN_USER",
              payload: {
                picture: res.data.picture,
                email: res.data.email,
                token: idTokenResult.token,
                _id: res.data._id,
              },
            })
          )
          .catch((error) => console.error(error));

        history.push("/");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const completeRegisterForm = () => (
    <form onSubmit={handleSubmit} className="">
      <Input type="email" className="regInput" value={email} disabled />
      <Input
        type="password"
        className="regInput"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoFocus
        placeholder="Password"
      />
      <br />
      <Button type="submit" basic color="purple">
        Complete registration
      </Button>
    </form>
  );

  return (
    <Layout>
      <div className="createImage"></div>
      <div className="home">
        <div className="ui container header2">
          <div className="regForm">
            <h2 className="subTitle">Complete Registretion</h2>
            <h3 className="subTitle">
              Please choose a password for your next login
            </h3>
            {completeRegisterForm()}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RegisterComplete;
